/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { useTranslations } from '@/hooks/useTranslations';
import { createStyles } from '@/utils/styles';
import { Button, FlexBox, Title } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

type Props = {
    onClick?: VoidFunction;
    disabled?: boolean;
};

export default function CreateUserButtonCard({ onClick, disabled = false }: Props) {
    const { t } = useTranslations();

    return (
        <FlexBox alignItems="Center" justifyContent="Center" style={styles.wrapper}>
            <FlexBox direction="Column" alignItems="Center" style={{ gap: 16 }}>
                <Button icon="add" style={{ width: 32 }} onClick={onClick} disabled={disabled} />
                <Title level="H6">{t('CREATE_USER')}</Title>
            </FlexBox>
        </FlexBox>
    );
}

const styles = createStyles({
    wrapper: {
        backgroundColor: 'white',
        borderRadius: ThemingParameters.sapElement_BorderCornerRadius,
        boxShadow: ThemingParameters.sapContent_Shadow0,
        minHeight: 150,
    },
});
